<template>
    <c-dialog ref="dialog" width="550" height="400">
        <c-steps :steps="steps" :active="active" gap="200" style="padding: 14px 0 0;"></c-steps>
        <c-form ref="chargeForm" vertical unit-width="100%">
            <template v-if="active == 1">
                <c-form-item label="充值金额" required>
                    <c-input class="m-price-input" type="number" decimal="2" :range="[0.01, 999999]"
                                v-model="amount" placeholder="请输入充值金额" append-text="元"></c-input>
                </c-form-item>

                <c-form-item label="支付方式" required :tip="payMethod == 'bankcard' ? '请确保银行卡内余额充足，仅支持个人卡中进行扣款充值' : ''">
                    <c-radio-group name="pay_method" class="s-normal" :options="payMethodDic" v-model="payMethod"></c-radio-group>
                    <c-select v-show="payMethod == 'bankcard'" name="bank_card_id" async @search="searchBankCard" v-model="bank_card_id" style="margin-top: 10px;">
                        <template #default="{valueData}">
                            <div class="card flex-center" style="background: #EFF4FF">
                                <div class="card-icon flex-center"><i class="tf">&#xe6a4;</i></div>
                                <p v-if="!valueData[0]" class="flex-grow" style="color: #f55;">请选择银行卡</p>
                                <p v-else class="flex-grow">{{valueData[0].data.bank_name}} ({{valueData[0].data.bank_card_no}})</p>
                                <i class="tf" style="color: var(--color-main)">&#xe6af;</i>
                            </div>
                        </template>
                        <template #option="{data}">
                            <div class="card card-option flex-center">
                                <div class="card-icon flex-center"><i class="tf">&#xe6a4;</i></div>
                                <p class="flex-grow">{{data.data.bank_name}} ({{data.data.bank_card_no}})</p>
                            </div>
                        </template>
                    </c-select>
                </c-form-item>
            </template>

            <template v-if="active == 2">
                <template v-if="payMethod == 'bankcard'">
                    <p style="width: 100%; padding: 24px 0 22px; font-size: 16px; font-weight: bold; text-align: center;">验证码将发送至 {{phone.replace(/^(\d{3})\d+(\d{4})$/, '$1****$2')}}，请注意查收</p>
                    <c-form-item label="短信验证码" required>
                        <c-input class="flex-grow" type="text" name="verify_code" v-model="verify_code" maxlength="6" :clear="false"></c-input>
                    </c-form-item>
                </template>
                <div v-else-if="qr_code_url" class="m-pay-qrcode-large">
                    <p class="m-pay-countdown">通联余额充值：￥{{amount}} 元</p>
                    <div class="m-pay-qrcode-border">
                        <c-qrcode :value="qr_code_url" size="200"></c-qrcode>
                    </div>
                    <p class="m-pay-scan-tip">请使用{{payMethod == 'wxpay_scan' ? '微信' : '支付宝'}}扫一扫完成支付</p>
                </div>
            </template>
        </c-form>

        <template #button>
            <c-button v-if="active == 1" size="dialog" color="main" @click="nextStep()">下一步</c-button>
            <c-button v-if="active == 2 && payMethod == 'bankcard'" color="main" size="dialog" @click="orderPay()">确认支付</c-button>
            <c-button size="dialog" @click="$refs.dialog.close()">取消</c-button>
        </template>
    </c-dialog>
</template>

<script>
import {mapState} from "vuex";
import qrcode from 'qrcode';

export default {
    name: 'accountRecharge',
    props: {
        workType: [String, Number]
    },
    watch: {
    },
    data() {
        return {
            amount:0,               //充值金额
            payMethod:'wxpay_scan',      //充值支付方式
            steps:[
                {'name': '发起充值申请'},
                {'name': '充值支付'}
            ],
            bank_card_id:0,
            phone:'',
            verify_code:'',
            qr_code_url:'',    //支付二维码
            biz_user_id: '',
            biz_order_no: '',

            active:1,
            import_type:1,
            excel_file:'',
            matchColumnList:[],
            sysColumnTotal:0,           //系统业务总列数
            excelColumnTotal:0,         //导入Excel总列表
            excelColumnOptions:[],       //导入Excel表头信息（去重）
            importResult:null,
            errorFlag:false,
            view_id:0,
            purchase_order_id:0,
            countdown: 600,
            countdownTimer: null,
            pollTimer: null,
            payMethodOptions: []
        }
    },

    computed: {
        // 获取dictName选项数据
        ...mapState(['saasInfo', 'payMethodDic']),

        countdownText() {
            var minutes = Math.floor(this.countdown / 60);
            var seconds = this.countdown % 60;
            return minutes + '分' + (seconds < 10 ? '0' : '') + seconds + '秒';
        }
    },

    methods: {
        /************打开新增、编辑弹窗，数据初始化**************/
        open() {
            this.amount = '';
            this.payMethod = 'wxpay_scan';
            this.$refs.chargeForm.clear();
            this.$refs.chargeForm.set({
                pay_method:this.payMethod
            });
            this.active = 1;//恢复初始值
            this.$refs.dialog.open({
                title: '资金账户充值'
            });
        },
        /*******搜索已绑定银行卡*****************/
        searchBankCard(keyword, resolve) {
            this.request({
                url: '/sys_saas/bankcard/options',
                data: {
                    bank_card_pro: 0,       //充值扣款账户，仅支持个人卡
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        //确定充值
        nextStep() {
            if (!this.amount || this.amount <= 0){
                this.$message({
                    message: '请输入充值金额',  // 提示内容,
                    type: 'warn'
                });
                return false;
            }
            //调用充值申请接口
            if (this.payMethod == 'bankcard' && (!this.bank_card_id || this.bank_card_id == 0)){
                this.$message({
                    message: '请选择充值支付的银行卡',  // 提示内容,
                    type: 'warn'
                });
                return false;
            }else {
                //发起充值申请
                this.request({
                    url: '/allinpay/deposit/apply',
                    data: {
                        user_type: 1,               //商户主账号
                        pay_method: this.payMethod,
                        bank_card_id: this.bank_card_id,
                        amount: this.amount
                    },
                    loading: {
                        message: '数据处理中...'
                    },
                    success: data => {
                        this.active = 2;
                        this.biz_user_id = data.biz_userid;
                        this.biz_order_no = data.biz_order_no;
                        //银行卡扣款，需要输入验证码
                        if (this.payMethod == 'bankcard'){
                            this.phone = data.phone;
                        }else {
                            this.qr_code_url = 'test_code';
                            if (data.payInfo) {
                                this.qr_code_url = data.payInfo;
                                this.startCountdown();
                                this.startPolling();
                            } else {
                                this.$message({message: '生成二维码失败', type: 'error'});
                            }
                        }
                    },
                    fail: (msg) => {
                        this.$message({message: msg, type: 'warn'});
                    }
                });
            }
        },
        //回退至上一步
        orderPay() {
            if (!this.verify_code || this.verify_code.trim() == ''){
                this.$message({message:'请输入支付验证码', type: 'warn'});
            }else {
                this.request({
                    url: '/allinpay/order/pay',
                    data: {
                        biz_user_id: this.biz_user_id,
                        biz_order_no: this.biz_order_no,
                        verify_code: this.verify_code
                    },
                    success: data => {
                        //支付成功
                        // this.$message({message:'充值支付成功', type: 'Success'});
                        //关闭页面
                        this.$refs.dialog.close();
                        this.$confirm({
                            type: 'success',
                            message:'已成功发送充值申请，到账可能稍有延迟，如果余额尚未更新，请自行刷新页面',
                            buttonName: '知道了',
                            cancelButton: false,
                            resolve: () => {
                                //关闭页面,执行回调方法
                                this.$emit('resolve');
                            }
                        })
                    }
                });
            }
        },

        //回退至上一步
        previousStep() {
            this.active = 1;
        },


        //完成
        finish() {
            this.$refs.dialog.close();
        },

        /************下载错误文件************/
        submit() {
            //判断【必填】项是否已填写
            var submitFlag = true;
            let data = this.$refs.table.getData();
            data.forEach(item => {
                if (item.required == 1
                        && (!item.excel_column_name || item.excel_column_name == '')
                        && (!item.column_default_value || item.column_default_value == '')
                ) {
                    submitFlag = false;
                    this.$message({
                        message: '请完善所有带星号的【必填】数据列',  // 提示内容,
                        type: 'warn'
                    });
                    return;
                }
            });
            if (submitFlag) {
                //返回解析完成数据
                this.request({
                    url: '/import/excel/data/list',
                    data: {
                        work_type: this.workType,
                        view_id: this.view_id,
                        url: this.excel_file,
                        match_column_list: data,
                        purchase_order_id:this.purchase_order_id
                    },
                    loading: {
                        message: '导入数据处理中...'
                    },
                    success: data => {
                        this.errorFlag = false;
                        this.importResult = data;
                        setTimeout(() => {
                            this.active = 3;//恢复初始值
                            //执行回调方法
                            this.$emit('resolve',this.importResult.import_data_list||[]);
                        }, 500);
                    },
                    fail: () => {
                        this.errorFlag = true;
                    }
                });
            }
        },
        /*********开始倒计时**********/
        startCountdown() {
            this.countdown = 600;
            this.countdownTimer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    this.clearTimers();
                    this.$message({message: '二维码已过期，请重新生成', type: 'warn'});
                }
            }, 1000);
        },

        /*********开始轮询支付状态**********/
        startPolling() {
            this.pollTimer = setInterval(() => {
                this.checkPayStatus();
            }, 3000);
        },

        /*********查询支付状态**********/
        checkPayStatus() {
            this.request({
                url: '/allinpay/deposit/apply/pay/check',
                data: {
                    biz_order_no:this.biz_order_no
                },
                success: data => {
                    if (data.status == 1) {
                        this.clearTimers();
                        this.$message({message: '支付成功', type: 'success'});
                        this.$refs.dialog.close();
                        this.$emit('resolve');
                    }
                }
            });
        },

        /*********清除定时器**********/
        clearTimers() {
            if (this.countdownTimer) {
                clearInterval(this.countdownTimer);
                this.countdownTimer = null;
            }
            if (this.pollTimer) {
                clearInterval(this.pollTimer);
                this.pollTimer = null;
            }
        },
    }
}
</script>

<style lang="stylus" scoped>
.m-pay-qrcode-large {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding-top: 10px;
    text-align: center;

    .m-pay-qrcode-border {
        padding: 12px;
        border: 5px solid var(--color-main);
        border-radius: 8px;
        background: #fff;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    .m-pay-scan-tip {
        font-size: 14px;
        color: #f55;
        font-weight: 500;
    }

    .m-pay-countdown {
        font-size: 14px;
        color: #666;
    }
}

.import-steps {
    padding: 10px 20px;
    background-color: #F8F8F8;

    h5 {
        line-height: 36px;
        font-size: 15px;
    }

    p {
        padding: 4px 0;
        line-height: 20px;
        color: #666;
    }
}

.import-explain {
    padding: 20px;

    >>> p {
        padding: 4px 0;
        line-height: 20px;
    }
}

.import-fruit {
    height: 200px;
    background-color: #F8F8F8;

    h1 {
        margin-bottom: 30px;
        font-size: 26px;
    }
}

.card {
    gap: 12px;
    height: 50px;
    border-radius: 6px;
    padding: 0 14px;
    font-size: 16px;
    cursor: pointer;

    &-option {
        &:hover {
            background: #F5F5F5;
        }
    }

    &-icon {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        font-size: 20px;
        color: #fff;
        background: var(--color-main);
    }
}
</style>